/**
 * @file: 立式货架tpl申明
 * @author: xiaolong.huang@dmall.com
 */

let tpl: string = `
    <div class="shelvesbuild-e-shelves-box" data-stagecore>
        <div class="shelvesbuild-e-shelves-box__error-txt"></div>
        <div class="shelves-box-title">
            <div class="J_BoxId"></div>
            <div class="J_BoxTitle"></div>
        </div>
        <!-- <div class="changeTab"></div> -->
        <div class="shelves-box J_ShelvesBox">
            <!-- 流动线 -->
            <span class="flow-border-left"><i></i></span>
            <span class="flow-border-right"><i></i></span>
            <span class="flow-border-top"><i></i></span>
            <span class="flow-border-bottom"><i></i></span>

            <!-- 实线边框 -->
            <span class="solid-border-left"></span>
            <span class="solid-border-right"></span>
            <span class="solid-border-top"></span>
            <span class="solid-border-bottom"></span>

            <div class="shelves-box-slot J_ElementBoxSlot slot"></div>
            <div class="shelves-box-footer J_ElementBoxFooterSlot"></div>
            <canvas class="left_grid grid--hide"></canvas>
            <canvas class="right_grid grid--hide"></canvas>
        </div>
        <span class="selected-mask"></span>
    </div>
`;

export default tpl;
